// Function to update the tab content
const updateTabContent = (trigger, target) => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });

  setTimeout(() => {
    trigger
      .closest('.tabs')
      .querySelectorAll('.tabs__item')
      .forEach((el) => {
        el.classList.remove('tabs__item--active');
        el.classList.add('tabs__item--inactive');
      });
    trigger.closest('.tabs').querySelector(`#${target}`).classList.remove('tabs__item--inactive');
    trigger.closest('.tabs').querySelector(`#${target}`).classList.add('tabs__item--active');
  }, 500);
};

(() => {
  // Support both horizontal tabs and sidebar tabs
  const horizontalTriggers = document.querySelectorAll('.tabs__nav .tab-trigger');
  const sidebarTriggers = document.querySelectorAll('.tabs__sidebar .tab-trigger');
  const allTriggers = [...horizontalTriggers, ...sidebarTriggers];

  allTriggers.forEach((el) => {
    el.addEventListener('click', () => {
      // Update active state of triggers (support both new and old classes)
      allTriggers.forEach((tab) => {
        tab.classList.remove('tab-trigger--active', 'link-styled--active');
      });

      // Add appropriate active class based on context
      if (el.closest('.tabs__nav')) {
        el.classList.add('tab-trigger--active');
      } else if (el.closest('.tabs__sidebar')) {
        el.classList.add('link-styled--active');
      }

      // Update tab content
      if (document.getElementById(el.dataset.trigger)) {
        updateTabContent(el, el.dataset.trigger);
        window.location.hash = el.dataset.trigger;
      }
    });
  });
})();

// Select menu event listener (for backward compatibility)
const selectElement = document.getElementById('TabsSidebarSelect');
if (selectElement) {
  selectElement.addEventListener('change', (el) => {
    if (document.getElementById(el.target.value)) {
      updateTabContent(el.target, el.target.value);
      window.location.hash = el.target.value;
    }
  });
}

// Accordion functionality
document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach((header) => {
    header.addEventListener('click', function () {
      const accordionItem = this.closest('.accordion-item');
      const isActive = accordionItem.classList.contains('active');

      // Close all other accordions in the same container
      const container = accordionItem.closest('.accordion-container');
      const allItems = container.querySelectorAll('.accordion-item');
      allItems.forEach((item) => {
        item.classList.remove('active');
      });

      // Toggle current accordion
      if (!isActive) {
        accordionItem.classList.add('active');
      }
    });
  });
});

// Check for URL hash on load
document.addEventListener('DOMContentLoaded', function () {
  var hash = window.location.hash;

  if (hash) {
    var id = hash.slice(1);
    var el = document.querySelector(`.tab-trigger[data-trigger="${id}"]`);
    el.click();
  }
});
